import React, { useState, useEffect } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { createStore } from 'stores/assignmentsActivity';
import { fetchAssignmentTable } from 'actions/assignmentActivity/assignments';
import { Spinner } from 'ui';
import ReminderModal from 'components/ReminderModal';
import IncompleteAssignmentModal from './IncompleteAssignmentModal';
import AssignmentTable from './AssignmentTable';

const store = createStore();

const UserProgressTable = () => {
  const dispatch = useDispatch();
  const [reminder, setReminder] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [remindAllUsers, setRemindAllUsers] = useState(null);
  const [incompleteActionModal, setIncompleteActionModal] = useState(false);
  const fetchUrl = window.location.pathname;

  const { loading, assignDirectly, meta } = useSelector(state => state);

  useEffect(() => {
    dispatch(fetchAssignmentTable(fetchUrl));
  }, [fetchUrl, dispatch]);

  if (loading) {
    return (
      <div className="mt-16 ta-c">
        <Spinner size="larger" />
      </div>
    );
  }

  return (
    <>
      <AssignmentTable
        assignment={assignDirectly.assignDirectly}
        metadata={meta.metadata}
        hideSelect
        hideAction={false}
        hideStatus={false}
        setReminder={setReminder}
        isManuallyTextAssignmentReminders={
          meta.isManuallyTextAssignmentReminders
        }
        assignmentId={1}
        setSelectedId={setSelectedId}
        setRemindAllUsers={setRemindAllUsers}
        setIncompleteActionModal={setIncompleteActionModal}
        hideCompleted={
          assignDirectly.assignDirectly[0].status === 'assigned' ||
          assignDirectly.assignDirectly[0].status === 'started' ||
          assignDirectly.assignDirectly[0].status === 'reassigned'
        }
      />
      {reminder && remindAllUsers && (
        <ReminderModal
          assignmentIds={remindAllUsers.assignment_ids}
          cannotReceiveSmsCount={remindAllUsers.cannot_receive_sms_count}
          assigneeCount={remindAllUsers.assignee_count}
          isVisible={reminder}
          setReminder={setReminder}
          setSelectedId={setSelectedId}
          companyName={meta.companyName}
          remindAllUsers={remindAllUsers.remind_all_users}
        />
      )}
      {incompleteActionModal && (
        <IncompleteAssignmentModal
          selectedIds={selectedId}
          singleId={selectedId}
          isVisible={incompleteActionModal}
          setShowModal={setIncompleteActionModal}
          setSelectedId={setSelectedId}
          markCompleteUserAssignment
        />
      )}
    </>
  );
};

export default props => (
  <Provider store={store}>
    <UserProgressTable {...props} />
  </Provider>
);
